import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["propertyNum", "entity", "propertyType", "region", "submitBtn", "errors"]
  static values = { updateUrl: String }

  async save() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this._hideErrors()
    this.submitBtnTarget.disabled = true
    this.submitBtnTarget.textContent = "Saving..."

    try {
      const response = await fetch(this.updateUrlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({
          property_num: this.propertyNumTarget.value,
          entity: this.entityTarget.value,
          property_type: this.propertyTypeTarget.value,
          region_id: this.regionTarget.value
        })
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Update card DOM
        const card = document.getElementById("re-location-card-body")
        if (card) {
          this._updateField(card, "property-num", data.property_num)
          this._updateField(card, "entity", data.entity)
          this._updateField(card, "property-type", data.property_type)
          this._updateField(card, "region", data.region)
        }

        // Update project name in header
        if (data.project_name) {
          const nameEl = document.querySelector("[data-project-name]")
          if (nameEl) nameEl.textContent = data.project_name
        }

        this._closeModal()
        this._showFlash("Settings updated successfully.")
      } else {
        this._showErrors(data.errors || ["Update failed"])
      }
    } catch {
      this._showErrors(["A network error occurred. Please try again."])
    } finally {
      this.submitBtnTarget.disabled = false
      this.submitBtnTarget.textContent = "Save Changes"
    }
  }

  _updateField(container, fieldName, value) {
    const el = container.querySelector(`[data-field="${fieldName}"]`)
    if (el) el.textContent = value || "—"
  }

  _showErrors(messages) {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.innerHTML = messages.map(m => `<p>${m}</p>`).join("")
    this.errorsTarget.classList.remove("hidden")
  }

  _hideErrors() {
    if (!this.hasErrorsTarget) return
    this.errorsTarget.classList.add("hidden")
    this.errorsTarget.innerHTML = ""
  }

  _closeModal() {
    // Find the parent modal element and close it directly
    this.element.classList.add("hidden")
    document.body.style.overflow = ""
  }

  _showFlash(message) {
    const container = document.createElement("div")
    container.className = "flash-toast-notice"
    container.dataset.controller = "flash"
    container.dataset.flashDismissAfterValue = "5000"
    container.setAttribute("role", "alert")

    const iconDiv = document.createElement("div")
    iconDiv.className = "shrink-0"
    iconDiv.innerHTML = `<svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>`

    const msgEl = document.createElement("p")
    msgEl.className = "flex-1 text-sm"
    msgEl.textContent = message

    container.appendChild(iconDiv)
    container.appendChild(msgEl)
    document.body.insertBefore(container, document.body.firstChild)
  }
}
